module.exports = __webpack_public_path__ + "images/category_lp/electric_tool/new/assessment_achievements/1@2x_1cd118ffb3e47461ea9998e72cabc203.png";